import * as Yup from 'yup';

const equipmentValidation = (t: (key: string) => string) => ({
  create: Yup.object().shape({
    device_code: Yup.string()
      .min(6, t('editEquipmentDialog.deviceCodeMax'))
      .required(t('editEquipmentDialog.deviceCodeRequired')),
  }),
  addSensor: Yup.object().shape({
    sensor_code: Yup.string().required(t('editSensorDialog.sensorCodeRequired')),
    sensor_type: Yup.string().required(t('editSensorDialog.sensorTypeRequired')),
  }),
  addDevice: Yup.object().shape({
    device_code: Yup.string().required(t('editEquipmentDialog.deviceCodeRequired')),
  }),
});

export default equipmentValidation;
